export const IS_STANDALONE = {
  YES : 'yes',
  NO  : 'no'
}
